namespace $.$$ {

	$mol_style_attach( '$shm_projects_page_release_stage_spin', `
		@keyframes shm_projects_page_release_stage_spin {
			to { transform: rotate(360deg); }
		}
		[shm_projects_page_release_stage][status="running"] [shm_projects_page_release_stage_marker] {
			border-right-color: transparent;
			animation: shm_projects_page_release_stage_spin .8s linear infinite;
		}
	` )

	$mol_style_define( $shm_projects_page, {

		height: '100%',
		minHeight: 0,

		Menu_page: {
			flex: {
				basis: '14rem',
				grow: 0,
				shrink: 0,
			},
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minWidth: 0,
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				gap: 0,
				padding: 0,
				overflow: 'hidden',
			},
		},

		Menu: {
			flex: {
				direction: 'column',
			},
		},

		Menu_title: {
			minWidth: 0,
			width: 0,
			padding: '0.5rem',
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
		},

		Project_actions: {
			padding: 0,
			width: '2.5rem',
			flex: {
				grow: 0,
				shrink: 0,
				basis: '2.5rem',
			},
		},

		Version_label: {
			padding: 0,
			color: $mol_theme.shade,
		},

		Product_page: {
			flex: { basis: '42rem', grow: 0, shrink: 1 },
			width: '42rem',
			maxWidth: '100%',
		},

		Draft_page: {
			flex: { basis: '42rem', grow: 0, shrink: 1 },
			width: '42rem',
			maxWidth: '100%',
		},

		Draft: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: '18rem',
		},

		Product_form: {
			minWidth: 0,
			padding: $mol_gap.block,
			Body: {
				gap: $mol_gap.block,
			},
		},

		Docs: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1 },
		},

		Project_tests: {
			minHeight: 0,
		},

		Dependency_details: {
			flex: { direction: 'column' },
			minWidth: 0,
		},

		Release_stage: {
			align: { items: 'center' },
			gap: $mol_gap.text,
			padding: { top: $mol_gap.text, bottom: $mol_gap.text },
			'[status]': {
				done: { color: $shm_theme.success },
				running: { color: $shm_theme.active },
				failed: { color: $shm_theme.error },
			},
		},

		Release_stage_marker: {
			boxSizing: 'border-box',
			width: '.75rem',
			height: '.75rem',
			border: { width: '2px', style: 'solid', color: $mol_theme.line },
			borderRadius: '50%',
			flex: { grow: 0, shrink: 0 },
		},

		Release_stage_title: {
			flex: { grow: 1, shrink: 1 },
			minWidth: 0,
		},

		Release_stage_elapsed: {
			color: $mol_theme.shade,
			font: { family: 'monospace' },
			flex: { grow: 0, shrink: 0 },
		},

		Versions: {
			flex: {
				direction: 'column',
			},
		},

		Version_link: {
			padding: $mol_gap.block,
		},

		Version_details: {
			flex: {
				direction: 'column',
			},
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Version_modes: {
			gap: 0,
			minWidth: 0,
			overflowX: 'auto',
			flexWrap: 'nowrap',
		},

		Version_result_mode: {
			flex: { shrink: 0 },
		},

		Version_benchmarks_mode: {
			flex: { shrink: 0 },
		},

		Version_session_mode: {
			flex: { shrink: 0 },
		},

		Version_session: {
			flex: { direction: 'column' },
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Version_benchmarks_panel: {
			flex: { direction: 'column' },
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Version_benchmark_chart_section: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			minWidth: 0,
			padding: { bottom: $mol_gap.block },
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_benchmark_chart_head: {
			align: { items: 'center' },
			justifyContent: 'space-between',
			gap: $mol_gap.text,
			flex: { wrap: 'wrap' },
		},

		Version_benchmark_chart_title: {
			font: { size: '1.1rem', weight: 'bold' },
		},

		Version_benchmark_lines: {
			flex: { grow: 0, shrink: 0 },
		},

		Version_benchmark_line_select: {
			minWidth: '22rem',
			maxWidth: '36rem',
			maxHeight: '28rem',
			overflowY: 'auto',
			padding: $mol_gap.text,
		},

		Version_benchmark_file_filters: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			minWidth: 0,
		},

		Version_benchmark_file_filters_title: {
			font: { weight: 'bold' },
			color: $mol_theme.shade,
		},

		Version_benchmark_files: {
			width: '100%',
			minWidth: 0,
		},

		Version_benchmark_chart_frame: {
			position: 'relative',
			width: '100%',
			height: '24rem',
			minHeight: '18rem',
			flex: { grow: 0, shrink: 0 },
		},

		Version_benchmark_legend: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			padding: { top: $mol_gap.block },
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_benchmark_legend_title: {
			font: { weight: 'bold' },
		},

		Version_benchmark_legend_list: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
		},

		Version_benchmark_legend_item: {
			flex: { direction: 'column' },
			gap: '.2rem',
			padding: $mol_gap.text,
			background: { color: $mol_theme.card },
		},

		Version_benchmark_legend_item_title: {
			font: { weight: 'bold' },
		},

		Version_benchmark_legend_item_description: {
			color: $mol_theme.shade,
		},

		Version_benchmark_info: {
			color: $mol_theme.shade,
		},

		Version_benchmark_run: {
			alignSelf: 'flex-start',
		},

		History_page: {
			flex: { basis: '19rem', grow: 0, shrink: 0 },
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				padding: 0,
			},
		},

		Version_page: {
			flex: { basis: '42rem', grow: 1, shrink: 1 },
			minWidth: 0,
			Title: {
				padding: 0,
			},
		},

		Version_date: {
			color: $mol_theme.shade,
		},

		Requirements_section: { flex: { direction: 'column' } },
		Version_stages_section: { flex: { direction: 'column' } },
		Version_stages_title: { font: { size: '1.1rem', weight: 'bold' } },
		Version_stage_list: { flex: { direction: 'column' } },
		Changes_section: {
			flex: { direction: 'column' },
			padding: { top: $mol_gap.block },
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Tests_section: { flex: { direction: 'column' } },
		Other_artifacts_section: { flex: { direction: 'column' } },

		Requirements_title: { font: { size: '1.1rem', weight: 'bold' } },
		Changes_title: { font: { size: '1.1rem', weight: 'bold' } },
		Tests_title: { font: { size: '1.1rem', weight: 'bold' } },
		Other_artifacts_title: { font: { size: '1.1rem', weight: 'bold' } },

		Change: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			padding: $mol_gap.text,
		},

		Change_screenshots: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
			gap: $mol_gap.block,
		},

		Change_screenshot: {
			flex: { direction: 'column' },
			height: '150px',
			padding: 0,
			overflow: 'hidden',
			border: { width: '1px', style: 'solid', color: $mol_theme.line },
		},

		Version_test: {
			gap: $mol_gap.text,
			padding: $mol_gap.text,
			justifyContent: 'flex-start',
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_benchmarks: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Version_benchmark_tables: {
			flex: { direction: 'column' },
		},

		Version_benchmark: {
			flex: { direction: 'column' },
			alignItems: 'stretch',
			gap: $mol_gap.text,
			padding: { bottom: $mol_gap.block },
		},

		Version_benchmark_title: {
			font: { size: '1.1rem', weight: 'bold' },
			padding: $mol_gap.text,
		},

		Version_benchmark_table_scroll: {
			overflowX: 'auto',
			minWidth: 0,
		},

		Version_benchmark_table: {
			display: 'table',
			width: '100%',
			minWidth: '36rem',
		},

		Version_benchmark_table_head: {
			display: 'table-header-group',
		},

		Version_benchmark_table_body: {
			display: 'table-row-group',
		},

		Version_benchmark_table_header: {
			display: 'table-row',
			background: { color: $mol_theme.card },
		},

		Version_benchmark_table_row: {
			display: 'table-row',
		},

		Version_benchmark_table_header_cell: {
			display: 'table-cell',
			padding: $mol_gap.text,
			color: $mol_theme.shade,
			font: { weight: 'bold' },
			whiteSpace: 'nowrap',
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_benchmark_table_cell: {
			display: 'table-cell',
			padding: $mol_gap.text,
			whiteSpace: 'nowrap',
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_benchmark_table_cell_difference: {
			display: 'inline',
			'@': {
				benchmark_change: {
					better: { color: $shm_theme.success },
					worse: { color: $shm_theme.error },
				},
			},
		},

		Other_artifact: {
			justifyContent: 'flex-start',
			padding: $mol_gap.text,
		},

	} )

}
